var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMacedonia01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 282.65 282.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .macedonia-1 {\n        fill: #d82126;\n      }\n\n      .macedonia-2 {\n        fill: #f8e92e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_\\xD1\\xEB\\xEE\\xE9_1",
    "data-name": "\\xD1\\xEB\\xEE\\xE9_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "macedonia-1",
    d: "M282.65,141.32c0,4.73-.23,9.41-.69,14.02-1.69,17.2-6.47,33.49-13.77,48.32-3.63,7.37-7.88,14.39-12.7,20.97-20.53,28.09-51.18,48.32-86.58,55.33-8.54,1.69-17.36,2.61-26.37,2.69h-2.44c-9-.07-17.8-.99-26.32-2.67-35.42-6.99-66.08-27.22-86.62-55.32-4.81-6.58-9.07-13.59-12.7-20.97-7.31-14.83-12.09-31.13-13.78-48.34-.45-4.61-.69-9.29-.69-14.02s.23-9.4.69-14.01c1.69-17.21,6.47-33.51,13.78-48.35,3.63-7.38,7.89-14.39,12.7-20.97C47.71,29.89,78.38,9.67,113.79,2.67c8.52-1.68,17.32-2.6,26.32-2.67h2.44c9.02.07,17.83.99,26.37,2.69,35.41,7,66.05,27.23,86.59,55.33,4.81,6.58,9.06,13.59,12.69,20.97,7.3,14.83,12.08,31.13,13.77,48.33.45,4.61.69,9.28.69,14.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "macedonia-2",
    d: "M168.92,2.69l-22.42,88.13c-1.69-.17-3.41-.26-5.14-.26s-3.45.09-5.14.26L113.79,2.67c8.52-1.68,17.32-2.6,26.32-2.67h2.44c9.02.07,17.83.99,26.37,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "macedonia-2",
    d: "M168.92,279.95c-8.54,1.69-17.36,2.61-26.37,2.69h-2.44c-9-.07-17.8-.99-26.32-2.67l22.42-88.15c1.69.17,3.41.26,5.14.26s3.46-.09,5.14-.26l22.42,88.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "macedonia-2",
    d: "M282.65,141.32c0,4.73-.23,9.41-.69,14.02l-90.09-9.03c.16-1.64.24-3.3.24-4.98s-.08-3.35-.24-4.98l90.09-9.03c.45,4.61.69,9.28.69,14.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "macedonia-2",
    d: "M90.6,141.32c0,1.68.09,3.34.25,4.98L.69,155.34c-.45-4.61-.69-9.29-.69-14.02s.23-9.4.69-14.01l90.16,9.03c-.16,1.64-.25,3.3-.25,4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "macedonia-2",
    d: "M268.2,78.98l-80.8,40.95c-1.58-3.41-3.53-6.6-5.8-9.55l73.92-52.37c4.81,6.58,9.06,13.59,12.69,20.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "macedonia-2",
    d: "M268.2,203.66c-3.63,7.37-7.88,14.39-12.7,20.97l-73.91-52.36c2.27-2.95,4.22-6.14,5.8-9.55l80.8,40.95Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "macedonia-2",
    cx: 141.36,
    cy: 141.32,
    r: 40.61,
    transform: "translate(-28.66 246.43) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "macedonia-2",
    d: "M101.12,110.38c-2.27,2.94-4.22,6.15-5.81,9.55L14.47,78.96c3.63-7.38,7.89-14.39,12.7-20.97l73.95,52.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "macedonia-2",
    d: "M101.12,172.26l-73.95,52.39c-4.81-6.58-9.07-13.59-12.7-20.97l80.85-40.97c1.59,3.41,3.53,6.61,5.81,9.56Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacedonia01);
export default __webpack_public_path__ + "static/media/Macedonia-01.20b3560ac985aac739f8281130d44ede.svg";
export { ForwardRef as ReactComponent };